import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c1fcf75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slide-inner--image",
  style: { backgroundImage: 'url(/international-trash-award-1.jpg)' }
}, null, -1))
const _hoisted_3 = { class: "slide-inner--info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_header_site = _resolveComponent("header-site")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_header_site),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('Международная')) + " ", 1),
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.$t('мусорная премия')), 1)
        ]),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToWinner && _ctx.goToWinner(...args))),
          "data-type": "page-transition",
          class: "ms-btn--slider"
        }, _toDisplayString(_ctx.$t('Победитель 2024')), 1)
      ])
    ])
  ], 64))
}